import { getID } from "src/libs/utilities"

const pe_widget = (): any[] => {
    return [
        {
            id: getID("pe-widget"),
            widgetId: "SearchBlock",
            width: 500,
            defaultTitle: "Поиск по сайту"
        },
        {
            id: getID("pe-widget"),
            type: "pe_widget", 
            width: 350,
            widgetId: "FreeMenu",
            attributes: { menu_id: "profile" },
            defaultTitle: "Меню сайта",
        }
    ]
}

export default pe_widget